import { POST_WITH_ID } from '@brickwise/asset-validation';
import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { convertToEuropeanNumber } from '../../../util/cashFlowUtils';

export const RentalSurplus = () => {
  const formik = useFormikContext<POST_WITH_ID>();

  const getOutcome = () => {
    const rentalIncome = formik.values.rentalDetails?.rentalIncome ?? 0;
    const managementFee = formik.values.rentalDetails?.managementFee ?? 0;
    const liquidityReserve = formik.values.rentalDetails?.liquidityReserve ?? 0;
    const additionalCosts = formik.values.rentalDetails?.additionalManagementCosts || [];
    const otherExpenses = additionalCosts.reduce((acc, expense) => {
      // TODO: Expense amount and name should be required
      if (expense.amount && expense.name) {
        return acc + expense.amount;
      }

      return 0;
    }, 0);

    if (
      typeof rentalIncome === 'number' &&
      typeof managementFee === 'number' &&
      typeof liquidityReserve === 'number' &&
      typeof otherExpenses === 'number'
    ) {
      const result = rentalIncome - managementFee - liquidityReserve - otherExpenses;
      return result;
    }
  };

  const rentalSurplusValue = getOutcome();

  useEffect(() => {
    formik.setFieldValue('rentalDetails.rentalSurplus', rentalSurplusValue);
  }, [rentalSurplusValue]);

  return <div data-cy="totalOutcome">{convertToEuropeanNumber(rentalSurplusValue || 0)} €</div>;
};
